import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Card, InputAdornment, Icon, Autocomplete, TextField, Divider,createFilterOptions } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setRouteReplayData,
  setHaltData,
  setIgnitionData,
  setRFIDData,
  clearRouteReplayData,
  clearRouteCurrentPacket,
  clearSeletectedJourneyPlotData,
} from "features/routeReplay/routeReplaySlice";
import { fetchJourneyData } from "features/routeReplay/routeReplayThunk";
import { fetchThingDetails } from "features/thing/thingThunk";
import { routeReplayReport, haltReport, ignition } from "config/apis";
import { setIsVehicle, setStoredTimes, setAutoLoadRoute } from "features/vehicle/vehicleSlice";
import DateRangePicker from "layouts/DateTimerange/dateTimeRange";

const FilterCard = ({ onClearTable }) => {
  const [vehicle, setVehicle] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();
  const things = useSelector((state) => state.things.filterThing || []);
  const isVehicle = useSelector((state) => state.vehicle.isVehicle) || "";

  const autoLoad = useSelector((state) => state.vehicle.autoLoadRoute);

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "";
    return dateTime.replace(/-/g, "/").replace("T", " ");
  };

  const formatForInput = (date) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

    const vehicleFilterOptions = createFilterOptions({
    stringify: (option) =>
      `${option?.name || ""} ${option?.nickName || ""} ${option?.vehicleNumber || ""} ${option?.id || ""}`,
  });

  // Date Limits Calculation
  // const now = new Date();

  // // Max Date: End of Today
  // const maxDate = new Date(now);
  // maxDate.setHours(23, 59, 0, 0);
  // const maxDateTimeString = formatForInput(maxDate);

  // // Min Date: 7 Days Ago
  // const minDate = new Date(now);
  // minDate.setDate(minDate.getDate() - 7);
  // minDate.setHours(0, 0, 0, 0);
  // const minDateTimeString = formatForInput(minDate);

  useEffect(() => {
    dispatch(fetchThingDetails());
  }, [dispatch]);

  useEffect(() => {
    if (!things.length || !isVehicle) return;
    const thing = things.find((e) => e.id === isVehicle);
    if (!thing) return;
    setVehicle(thing.id);
    const now = new Date();
    const start = new Date(now); start.setHours(0, 0, 0, 0);
    const end = new Date(now); end.setHours(23, 59, 0, 0);
    setStartTime(formatForInput(start));
    setEndTime(formatForInput(end));
  }, [things, isVehicle]);

  useEffect(() => {
    // Jab autoLoad true ho aur teeno fields (vehicle, start, end) populate ho jayein
    if (autoLoad && vehicle && startTime && endTime) {
      handleLoad();
      // Hit karne ke baad autoLoad ko false kar dein taaki loop na bane
      dispatch(setAutoLoadRoute(false));
    }
  }, [autoLoad, vehicle, startTime, endTime]);

  const fetchAndDispatch = async (url, body, action, label, headers) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (response.ok) {
        dispatch(action(data));
      }
    } catch (err) {
      console.error(`${label} Error:`, err);
    }
  };

  const handleClear = () => {
    setVehicle(""); setStartTime(""); setEndTime(""); setError(null);
    dispatch(clearRouteReplayData());
    dispatch(clearRouteCurrentPacket());
    dispatch(clearSeletectedJourneyPlotData());

    if (onClearTable) {
      onClearTable();
    }
  };

  // Inside FilterCard.js -> handleLoad function

  const handleLoad = async () => {

    const start = new Date(startTime);
    const end = new Date(endTime);

    if (end < start) {
      setError("End time should be greater than start time.");
      setLoading(false);
      return;
    }

    if (!vehicle || !startTime || !endTime) {
      setError("Please fill in all fields.");
      return;
    }
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("token");
    const apiStart = formatDateTime(startTime);
    const apiEnd = formatDateTime(endTime);

    dispatch(setStoredTimes({ start: startTime, end: endTime }));

    const headers = {
      "x-dhundhoo-session": token,
      "Content-Type": "application/json",
    };

    // Clear previous data
    dispatch(clearRouteReplayData());
    dispatch(clearRouteCurrentPacket());
    dispatch(clearSeletectedJourneyPlotData());

    // ONLY fetch Route Replay data here
    await fetchAndDispatch(
      `${routeReplayReport}/${vehicle}`,
      { timeZone: "Asia/Kolkata", startTime: apiStart, endTime: apiEnd },
      setRouteReplayData,
      "Route Replay",
      headers
    );

    setLoading(false);
  };

  return (
    <MDBox p={2}>
      <Card sx={{ boxShadow: "none" }}>
          {/* <Autocomplete
          options={things}
          getOptionLabel={(option) =>
            `${option?.name || ""} ${option?.nickName ? `- ${option.nickName}` : ""}`
          }
          value={things.find((v) => v.id === vehicle) || null}
          onChange={(event, newValue) => {
            const id = newValue ? newValue.id : "";
            setVehicle(id);
            dispatch(setIsVehicle(id));
          }}
          renderOption={(props, option) => (
            <li
              {...props}
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>
                {option.nickName}
              </span>
              <span>{option.name}</span>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search Vehicle / Route"
              fullWidth
              size="small"
              disabled={loading}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FB8C00",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#FB8C00",
                },
              }}
            />
          )}
          sx={{ mb: 2 }}
        /> */}
   <Autocomplete
          options={things}
          filterOptions={vehicleFilterOptions}
          getOptionLabel={(option) =>
            `${option?.name || ""} ${option?.nickName ? `- ${option.nickName}` : ""}`
          }
          value={things.find((v) => v.id === vehicle) || null}
          onChange={(event, newValue) => {
            const id = newValue ? newValue.id : "";
            setVehicle(id);
            dispatch(setIsVehicle(id));
          }}
          renderOption={(props, option) => (
            <li
              {...props}
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>
                {option.nickName}
                {option.vehicleNumber ? ` (${option.vehicleNumber})` : ""}
              </span>
              <span>{option.name}</span>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select the vehicle"
              fullWidth
              size="small"
              disabled={loading}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FB8C00",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#FB8C00",
                },
              }}
            />
          )}
          sx={{ mb: 2 }}
        />

        <MDBox display="flex" alignItems="center" gap={1} mb={2}>
          <DateRangePicker
            startTime={startTime}
            endTime={endTime}
            onChange={({ startTime: s, endTime: e }) => { setStartTime(s); setEndTime(e); }}
            disabled={loading}
          />
        </MDBox>

        {error && <MDBox sx={{ color: "red", fontSize: "0.875rem", mb: 2 }}>{error}</MDBox>}

        <MDBox display="flex" gap={1} mt={2}>
          <MDButton variant="contained" color="info" fullWidth onClick={handleLoad} disabled={loading} sx={{ backgroundColor: "#1398DC", "&:hover": { backgroundColor: "#1398DC" } }}>
            {loading ? "Loading..." : "Load"}
          </MDButton>
          <MDButton variant="outlined" color="secondary" fullWidth onClick={handleClear} disabled={loading}>Clear</MDButton>
        </MDBox>
      </Card>
    </MDBox>
  );
};

export default FilterCard;